import { render, staticRenderFns } from "./ApprovalDialog.vue?vue&type=template&id=4e4e6941&scoped=true"
import script from "./ApprovalDialog.vue?vue&type=script&lang=js"
export * from "./ApprovalDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4e6941",
  null
  
)

export default component.exports